module.exports = __webpack_public_path__ + "img/download-1.9d17b0cc.png";